import { createBrowserHistory } from 'history';
import qhistory from 'qhistory';
import { parse } from 'qs';
import { serializeParams } from './utilities/serializeParams';
const browserHistory = qhistory(createBrowserHistory(), serializeParams, parse);
export default browserHistory;
//# sourceMappingURL=browserHistory.js.map